module.exports = __webpack_public_path__ + "static/media/TheinhardtRegular.cc907930.woff2";